import React, { useState } from 'react'
import { Search, X } from 'lucide-react'

// The big search box. Exact match only (the backend never does a partial
// one): a lead ID, an email or a phone. Submitting an empty box clears the
// search and goes back to browsing the range.
export default function InspectorSearch({ value, onSearch }) {
  const [text, setText] = useState(value)
  // A new search from outside (back/forward, a link) replaces the box.
  const [prev, setPrev] = useState(value)
  if (value !== prev) {
    setPrev(value)
    setText(value)
  }

  const submit = (e) => {
    e.preventDefault()
    onSearch(text.trim())
  }
  const clear = () => {
    setText('')
    if (value) onSearch('')
  }

  return (
    <form role="search" onSubmit={submit} className="li-search">
      <div style={{ position: 'relative', flex: 1, minWidth: 0, display: 'flex' }}>
        <Search size={18} aria-hidden="true" style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)' }} />
        <label htmlFor="li-search-input" className="sr-only" style={srOnly}>Search leads</label>
        <input
          id="li-search-input"
          type="search"
          autoComplete="off"
          placeholder="Lead ID, email or phone…"
          value={text}
          onChange={(e) => setText(e.target.value)}
          style={{ paddingRight: text ? 40 : 14 }}
        />
        {text && (
          <button
            type="button"
            onClick={clear}
            aria-label="Clear search"
            style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', padding: 6, cursor: 'pointer', color: 'var(--text-muted)', display: 'flex' }}
          >
            <X size={16} aria-hidden="true" />
          </button>
        )}
      </div>
      <button type="submit" className="btn btn-primary">Search</button>
    </form>
  )
}

const srOnly = { position: 'absolute', width: 1, height: 1, padding: 0, margin: -1, overflow: 'hidden', clip: 'rect(0, 0, 0, 0)', whiteSpace: 'nowrap', border: 0 }
